module.exports = __webpack_public_path__ + "img/backyard-bushes-by-water.d7057f80.jpg";